// Static lookup of common DMV neighborhoods + approximate lat/lng centroids.
// Used to power the registration form's "neighborhood" select and to derive
// a reasonable pin location without exposing exact addresses.

export const DC_WARDS = ["1", "2", "3", "4", "5", "6", "7", "8"];

export const NEIGHBORHOODS = [
  // --- DC ---
  { name: "Adams Morgan", jurisdiction: "DC", ward: "1", lat: 38.9217, lng: -77.0421 },
  { name: "Columbia Heights", jurisdiction: "DC", ward: "1", lat: 38.9286, lng: -77.0322 },
  { name: "Mount Pleasant", jurisdiction: "DC", ward: "1", lat: 38.9305, lng: -77.0387 },
  { name: "Dupont Circle", jurisdiction: "DC", ward: "2", lat: 38.9097, lng: -77.0434 },
  { name: "Georgetown", jurisdiction: "DC", ward: "2", lat: 38.9076, lng: -77.0723 },
  { name: "Logan Circle", jurisdiction: "DC", ward: "2", lat: 38.9097, lng: -77.0297 },
  { name: "Cleveland Park", jurisdiction: "DC", ward: "3", lat: 38.9342, lng: -77.0581 },
  { name: "Tenleytown", jurisdiction: "DC", ward: "3", lat: 38.9479, lng: -77.0792 },
  { name: "Petworth", jurisdiction: "DC", ward: "4", lat: 38.9425, lng: -77.0237 },
  { name: "Brightwood", jurisdiction: "DC", ward: "4", lat: 38.9601, lng: -77.0289 },
  { name: "Brookland", jurisdiction: "DC", ward: "5", lat: 38.9329, lng: -76.9956 },
  { name: "Edgewood", jurisdiction: "DC", ward: "5", lat: 38.9239, lng: -76.9929 },
  { name: "Capitol Hill", jurisdiction: "DC", ward: "6", lat: 38.8869, lng: -76.9967 },
  { name: "H Street Corridor", jurisdiction: "DC", ward: "6", lat: 38.9006, lng: -76.9909 },
  { name: "Deanwood", jurisdiction: "DC", ward: "7", lat: 38.9056, lng: -76.9356 },
  { name: "Hillcrest", jurisdiction: "DC", ward: "7", lat: 38.8632, lng: -76.9442 },
  { name: "Anacostia", jurisdiction: "DC", ward: "8", lat: 38.8639, lng: -76.9856 },
  { name: "Congress Heights", jurisdiction: "DC", ward: "8", lat: 38.8401, lng: -76.9959 },
  // --- Maryland ---
  { name: "Hyattsville", jurisdiction: "MD", lat: 38.9559, lng: -76.9456 },
  { name: "Silver Spring", jurisdiction: "MD", lat: 38.9907, lng: -77.0261 },
  { name: "Bethesda", jurisdiction: "MD", lat: 38.9847, lng: -77.0947 },
  { name: "College Park", jurisdiction: "MD", lat: 38.9897, lng: -76.9378 },
  { name: "Largo", jurisdiction: "MD", lat: 38.8804, lng: -76.8275 },
  { name: "Rockville", jurisdiction: "MD", lat: 39.0840, lng: -77.1528 },
  // --- Virginia ---
  { name: "Arlington", jurisdiction: "VA", lat: 38.8816, lng: -77.0910 },
  { name: "Alexandria", jurisdiction: "VA", lat: 38.8048, lng: -77.0469 },
  { name: "Falls Church", jurisdiction: "VA", lat: 38.8823, lng: -77.1711 },
  { name: "Fairfax", jurisdiction: "VA", lat: 38.8462, lng: -77.3064 },
];

export function findNeighborhood(name) {
  return NEIGHBORHOODS.find((n) => n.name === name);
}
